import { createGenericReducer } from "common/genericReducer";
import { combineReducers } from "redux";
import {
  CUSTOMER_ME_PATCH_RECEIVED,
  CUSTOMER_ME_PATCH_REQUESTED,
  CUSTOMER_ME_PATCH_REQUEST_FAILED,
  CUSTOMER_ME_PATCH_REQUEST_RESET,
  CUSTOMER_ME_RECEIVED,
  CUSTOMER_ME_REQUESTED,
  CUSTOMER_ME_REQUEST_FAILED
} from "./customerActions";

const createCustomerReducer = () => {
  return createGenericReducer(CUSTOMER_ME_REQUESTED, CUSTOMER_ME_RECEIVED, CUSTOMER_ME_REQUEST_FAILED);
};

const createCustomerUpdateReducer = () => {
  return createGenericReducer(
    CUSTOMER_ME_PATCH_REQUESTED,
    CUSTOMER_ME_PATCH_RECEIVED,
    CUSTOMER_ME_PATCH_REQUEST_FAILED,
    CUSTOMER_ME_PATCH_REQUEST_RESET
  );
};

export const customer = combineReducers({
  customerMe: createCustomerReducer(),
  customerUpdate: createCustomerUpdateReducer()
});
